import React from "react";
import Navbar from "./Navbar";

const ErrorPage = () => {
    return (
        <div>
            <Navbar />
            <h2>I'm Sorry, I can't always be sweet. Please try again later!</h2>
        </div>
    )
};

export default ErrorPage;